// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export * from '../exports';
export * from '/Users/jilin/projects/antd/rc-dialog/node_modules/dumi/dist/client/theme-api/index.js';
export * from './meta/exports';
